




































import { Component, Watch, Vue, Emit } from 'vue-property-decorator';
import { institutionServer, patrolManagementServe, professionServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component
export default class PatrolTaskAdd extends Vue {
  private visible = false;
  private type = '';

  private patrolLineList: any = []; // 巡检线路列表
  private postList: any = []; // 岗位列表
  private deptList: any = []; // 部门列表
  private staffList: any = [];

  private form: any = {
    loading: false,
    name: '',
    time: '',
    startTime: '',
    endTime: '',
    lineId: '',
    staffList: [],
    deptId: '',
    postId: '',
  };
  private formRules = {
    name: [{ required: true, message: '请输入巡检任务名称', trigger: 'blur' }],
    time: [{ required: true, message: '请选择巡检时间', trigger: 'blur' }],
    lineId: [{ required: true, message: '请选择巡检线路', trigger: 'change' }],
    staffList: [{ required: true, message: '请选择巡检人员', trigger: 'change' }],
  };
  private addLoading: any = false;

  created() {}

  changeStaff(e: any) {
    this.form.staffList = [];
    this.getSpaceStaffListAll({ deptId: e ? e : '' });
  }

  /**
   * 窗口标题
   */
  get title() {
    const typeMap: any = {
      add: '添加巡检任务',
    };
    return typeMap[this.type];
  }

  /**
   * 打开新增窗口
   */
  async showAddDialog() {
    this.form = {
      loading: false,
      name: '',
      time: '',
      startTime: '',
      endTime: '',
      lineId: '',
      staffList: [],
      deptId: '',
      postId: '',
    };
    this.type = 'add';
    this.visible = true;
    await this.getSpaceDeptList();
    await this.getPostList({});
    await this.getPatrolLineList({ paging: false });
  }

  /**
   * 【按钮】取消按钮
   * @Params
   * @return
   **/
  handleCancelBtnClick() {
    this.hideDialog();
  }

  /**
   * 【按钮】提交按钮点击
   */
  handleSubmitBtnClick() {
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      this.addTaskData();
    });
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    this.form = {
      loading: false,
      name: '',
      time: '',
      startTime: '',
      endTime: '',
      lineId: '',
      staffList: [],
      deptId: '',
      postId: '',
    };
  }

  /**
   * 关闭窗口
   */
  hideDialog() {
    this.resetForm();
    this.visible = false;
  }

  /**
   *【接口】获取岗位
   * @Params
   * @return
   **/
  async getPostList(opts: object) {
    try {
      const res: any = await professionServer.getPageDataAll(opts);
      if (res.code === '200') {
        this.postList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }
  /**
   *【接口】获取部门
   * @Params
   * @return
   **/
  async getSpaceDeptList() {
    try {
      const res: any = await institutionServer.getDeptAndSubDeptList({});
      if (res.code === '200') {
        this.deptList = arrayToTree(res.data);
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】获取巡检线路
   * @Params
   * @return
   **/
  async getPatrolLineList(opts: object) {
    try {
      const res: any = await patrolManagementServe.getPatrolLineListAll(opts);
      if (res.code === '200') {
        this.patrolLineList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】获取人员
   * @Params
   * @return
   **/
  async getSpaceStaffListAll(opts: object) {
    try {
      const res: any = await userServe.getPageDataAll(opts);
      if (res.code === '200') {
        this.staffList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】添加巡检任务
   */
  async addTaskData() {
    this.addLoading = true;
    patrolManagementServe
      .addPatrolTask({
        name: this.form.name,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        lineId: this.form.lineId,
        staffList: this.form.staffList,
        deptId: this.form.deptId,
        postId: this.form.postId,
        isEnable: 1,
      })
      .then((res: any) => {
        if (res.code == 201) {
          this.hideDialog();
          this.$emit('on-response');
          this.addLoading = false;
          this.$message.success('巡检任务创建成功。');
        } else {
          this.$message.warning(res.msg);
          this.addLoading = false;
        }
      })
      .catch((error: any) => {
        this.addLoading = false;
      });
  }

  /**
   * 【监听】监听时间组件值
   */
  @Watch('form.time')
  onTimeChanged(val: string[], oldVal: string[]) {
    if (!val) {
      return;
    }
    if (val.length > 0) {
      this.form.startTime = val[0];
      this.form.endTime = val[1];
    } else {
      this.form.startTime = '';
      this.form.endTime = '';
    }
  }
}
